<!-- Contenitore principale del componente -->
<ng-container *ngIf="configuration">
  
  <!-- Se la configurazione è disabilitata, non mostrare nulla -->
  <ng-container *ngIf="!configuration.enabled">
    <!-- Il componente è disabilitato, verrà usato il fallback (lang-download-file) -->
  </ng-container>

  <!-- Se la configurazione è abilitata, mostra il menu -->
  <ng-container *ngIf="configuration.enabled">
    
    <!-- Gestione del tipo di bottone tramite ngSwitch -->
    <ng-container [ngSwitch]="configuration.buttonType">
      
      <!-- Bottone tipo mat-mini-fab -->
      <ng-container *ngSwitchCase="'mat-mini-fab'">
        <button
          [matMenuTriggerFor]="downloadMenu"
          (menuOpened)="onMenuOpened()"
          mat-mini-fab
          [color]="configuration.color"
          [disabled]="isLoading"
          [attr.aria-label]="'Scarica documenti'"
          class="work-order-download-button">
          
          <!-- Mostra spinner durante il caricamento -->
          <mat-spinner *ngIf="isLoading" diameter="20"></mat-spinner>
          
          <!-- Icona normale quando non sta caricando -->
          <mat-icon *ngIf="!isLoading">{{ configuration.icon }}</mat-icon>
        </button>
      </ng-container>

      <!-- Bottone tipo mat-icon-button (default) -->
      <ng-container *ngSwitchDefault>
        <button
          [matMenuTriggerFor]="downloadMenu"
          (menuOpened)="onMenuOpened()"
          mat-icon-button
          [color]="configuration.color"
          [disabled]="isLoading"
          [attr.aria-label]="'Scarica documenti'"
          class="work-order-download-button">
          
          <!-- Mostra spinner durante il caricamento -->
          <mat-spinner *ngIf="isLoading" diameter="20"></mat-spinner>
          
          <!-- Icona normale quando non sta caricando -->
          <mat-icon *ngIf="!isLoading">{{ configuration.icon }}</mat-icon>
        </button>
      </ng-container>
      
    </ng-container>

    <!-- Menu a tendina per selezionare cosa scaricare -->
    <mat-menu #downloadMenu="matMenu" class="work-order-download-menu">
      
      <!-- Messaggio di errore se il caricamento è fallito -->
      <div *ngIf="hasError" class="menu-error-message" mat-menu-item [disabled]="true">
        <mat-icon class="error-icon">error_outline</mat-icon>
        <span>Errore nel caricamento dei documenti</span>
      </div>

      <!-- ✅ Indicatore di caricamento documenti -->
      <div *ngIf="isLoading && !filesLoaded" class="menu-loading-message" mat-menu-item [disabled]="true">
        <mat-spinner diameter="16" class="loading-spinner"></mat-spinner>
        <span class="loading-text">Caricamento documenti...</span>
      </div>

      <!-- Lista degli elementi del menu -->
      <ng-container *ngFor="let item of menuItems">
        
        <!-- Separatore visivo per dividere PDF generato da documenti caricati -->
        <div *ngIf="item.isSeparator" class="menu-separator" mat-menu-item [disabled]="true">
          <span class="separator-label">{{ item.fileName }}</span>
        </div>

        <!-- Elemento del menu cliccabile -->
        <ng-container *ngIf="!item.isSeparator">
          
          <!-- PDF Generato (con o senza bandiera lingua) -->
          <button 
            *ngIf="item.type === 'generated'"
            mat-menu-item
            (click)="onMenuItemClick(item)"
            class="menu-item generated-pdf-item">
            
            <!-- Bandiera della lingua (se presente) -->
            <i *ngIf="item.languageData" [class]="getLanguageFlagClass(item)" class="language-flag"></i>
            
            <!-- Icona del file (se abilitata e NON c'è bandiera) -->
            <mat-icon *ngIf="configuration.showFileIcon && !item.languageData" class="file-icon">
              {{ getFileIcon(item) }}
            </mat-icon>
            
            <!-- Nome del file/lingua -->
            <span class="file-name"> {{ item.fileName }}</span>
          </button>

          <!-- File caricati -->
          <button 
            *ngIf="item.type === 'uploaded'"
            mat-menu-item
            (click)="onMenuItemClick(item)"
            class="menu-item uploaded-file-item">
            
            <!-- Icona del file -->
            <mat-icon *ngIf="configuration.showFileIcon" class="file-icon">
              {{ getFileIcon(item) }}
            </mat-icon>
            
            <!-- Nome del file -->
            <span class="file-name">{{ item.fileName }}</span>
          </button>

        </ng-container>

      </ng-container>

      <!-- Messaggio quando non ci sono documenti (oltre al PDF generato) -->
      <div 
        *ngIf="!isLoading && !hasError && menuItems.length === 1" 
        class="no-documents-message" 
        mat-menu-item 
        [disabled]="true">
        <mat-icon class="info-icon">info_outline</mat-icon>
        <span>Nessun documento caricato</span>
      </div>

    </mat-menu>

  </ng-container>

</ng-container>
